// import { createSelector } from '@reduxjs/toolkit';
// Types
import Reducers from 'app/types/Reducers';
// Models
import { RootState } from 'app/store';

export const selectOrders = (state:RootState) => state[Reducers.BillingOrders].orders;
export const selectLoading = (state:RootState) => state[Reducers.BillingOrders].loading;
export const selectParams = (state:RootState) => state[Reducers.BillingOrders].params;
